import { Injectable, signal } from '@angular/core';
import { translateApiMessage } from '../utils/api-message-translator.utils';

export type ToastType = 'success' | 'error' | 'warning' | 'info';
export type ToastPosition = 'top-right' | 'bottom-right';

export interface Toast {
  id: number;
  type: ToastType;
  message: string;
  duration: number;
  position: ToastPosition;
}

@Injectable({ providedIn: 'root' })
export class ToastService {

  readonly toasts = signal<Toast[]>([]);

  private _idCounter = 0;

  show(message: string, type: ToastType = 'info', duration = 4000, position: ToastPosition = 'bottom-right'): void {
    const id = ++this._idCounter;
    this.toasts.update(list => [...list, { id, type, message: translateApiMessage(message), duration, position }]);

    if (duration > 0) {
      setTimeout(() => this.dismiss(id), duration);
    }
  }

  success(message: string, duration = 4000, position: ToastPosition = 'bottom-right'): void {
    this.show(message, 'success', duration, position);
  }

  error(message: string, duration = 5000, position: ToastPosition = 'bottom-right'): void {
    this.show(message, 'error', duration, position);
  }

  warning(message: string, duration = 4000, position: ToastPosition = 'bottom-right'): void {
    this.show(message, 'warning', duration, position);
  }

  info(message: string, duration = 4000, position: ToastPosition = 'bottom-right'): void {
    this.show(message, 'info', duration, position);
  }

  dismiss(id: number): void {
    this.toasts.update(list => list.filter(t => t.id !== id));
  }
}
